import React, { ReactElement } from 'react'
import styled from 'styled-components'

import payIcon from 'assets/images/pay-icon.svg'
import { t } from 'i18next'

const InstructionItems = (): ReactElement => {
    return (
        <List data-testid="instruction-items">
            <ListItem>
                <div>
                    <ListHeading>
                        {t('instructions.steps.one.heading')}
                    </ListHeading>
                    <Description>
                        {t('instructions.steps.one.description')}
                    </Description>
                </div>
            </ListItem>
            <ListItem>
                <div>
                    <ListHeading>
                        {t('instructions.steps.two.heading_1')}{' '}
                        <figure>
                            <img
                                src={payIcon}
                                width="13"
                                height="13"
                                alt="pay-icon"
                            />
                        </figure>{' '}
                        {t('instructions.steps.two.heading_2')}
                    </ListHeading>
                    <Description>
                        {t('instructions.steps.two.description')}
                    </Description>
                </div>
            </ListItem>
            <ListItem>
                <div>
                    <ListHeading>
                        {t('instructions.steps.three.heading')}
                    </ListHeading>
                    <Description>
                        {t('instructions.steps.three.descripktion')}
                    </Description>
                </div>
            </ListItem>
        </List>
    )
}

const List = styled.ol`
    counter-reset: detail;
    margin-bottom: 0;
    padding: 0;
    @media (min-width: 768px) {
        margin-top: 0;
        padding: 1rem;
        border: 2px solid #00aed6;
        border-radius: 1rem;
        float: right;
        width: 60%;
        margin-right: 2.5%;
    }
`

const ListItem = styled.li`
    display: flex;
    padding: 1rem;
    border-radius: 0rem;
    color: #ffffff;
    background-color: #00aed6;
    background-image: -webkit-radial-gradient(
        left,
        circle closest-corner,
        rgba(255, 255, 255, 0.24),
        rgba(255, 255, 255, 0.24) 80%,
        transparent 80%
    );
    background-image: radial-gradient(
        circle closest-corner at left,
        rgba(255, 255, 255, 0.24),
        rgba(255, 255, 255, 0.24) 80%,
        transparent 80%
    );

    &:before {
        counter-increment: detail;
        content: counter(detail);
        flex-shrink: 0;
        margin-right: 0.75rem;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        font-weight: bold;
        line-height: 2rem;
        text-align: center;
        color: #1c1d1d;
        background-color: #ffffff;
    }
    &:not(:first-child) {
        margin-top: 1rem;
    }
    @media (min-width: 426px) {
        border-radius: 1rem;
    }
    @media (min-width: 768px) {
        &:before {
            color: #fff;
            background-color: #00aed6;
        }
        padding: 0;
        color: inherit;
        background-color: inherit;
    }
`

const ListHeading = styled.h3`
    margin-top: 0;
    margin-bottom: 0.25rem;
    font-size: 1.3125rem;
    line-height: 1.75rem;

    figure {
        display: inline-flex;
        padding: 0.25rem;
        border-radius: 0.25rem;
        background-color: #2c62ba;
    }
`

export const Description = styled.p`
    margin: 0 0 1em;
    line-height: 1.3125rem;
    font-size: 0.94rem;
`
export default InstructionItems
